module.exports = __webpack_public_path__ + "static/media/ploni-light-aaa.2e3fbdb7.woff2";